import React from "react";
import CustomButton from "../../../components/common/CustomButton";

const AdvocatesInfo = ({ isOpen, onClose, form, setForm, handleSubmit, loading }) => {
  if (!isOpen) return null;

  const handleInputChange = (field, value) => {
    if (field === "phone") {
      // Allow only digits
      value = value.replace(/[^0-9]/g, "").slice(0, 10);
    }
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCancel = () => {
    setForm({
      advocateId: "",
      name: "",
      email: "",
      phone: "",
      officeAddress: "",
    });
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="w-[95%] max-w-lg p-4 bg-white rounded-xl shadow-lg overflow-hidden animate-fadeIn">
        {/* Header */}
        <div className="flex items-center rounded-md justify-between bg-slate-100 px-5 py-3 border-b">
          <h2
            id="modal-title"
            className="text-lg font-semibold text-customGreen"
          >
            {form?.advocateId ? "Edit Advocate" : "Add New Advocate"}
          </h2>
          <button
            onClick={onClose}
            className="hover:bg-red-50 border border-red-200 p-2 text-red-500 rounded-full w-9 h-9 flex items-center justify-center transition"
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 
                0 111.414 1.414L11.414 10l4.293 
                4.293a1 1 0 01-1.414 
                1.414L10 11.414l-4.293 
                4.293a1 1 0 
                01-1.414-1.414L8.586 
                10 4.293 5.707a1 1 0 
                010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Advocate Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Advocate Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                maxLength={100}
                value={form.name}
                onChange={(e) => handleInputChange("name", e.target.value)}
                className="w-full px-3 py-2 border rounded-lg input-focus"
                placeholder="Enter advocate name"
                autoFocus
                disabled={loading}
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email Address <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                maxLength={100}
                value={form.email}
                onChange={(e) => handleInputChange("email", e.target.value)}
                className="w-full px-3 py-2 border rounded-lg input-focus"
                placeholder="Enter email address"
                disabled={loading}
              />
            </div>

            {/* Phone */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Phone Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                maxLength={10}
                value={form.phone}
                onChange={(e) => handleInputChange("phone", e.target.value)}
                className="w-full px-3 py-2 border rounded-lg input-focus"
                placeholder="Enter 10-digit phone number"
                disabled={loading}
                pattern="[0-9]*"
                inputMode="numeric"
              />
            </div>

            {/* Office Address */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Office Address
              </label>
              <textarea
                maxLength={200}
                rows={3}
                value={form.officeAddress}
                onChange={(e) => handleInputChange("officeAddress", e.target.value)}
                className="w-full px-3 py-2 border rounded-lg input-focus"
                placeholder="Enter office address"
                disabled={loading}
              />
            </div>

            {/* Footer Buttons */}
            <div className="flex justify-end gap-3 pt-4 border-t">
              <button
                type="button"
                onClick={handleCancel}
                className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition text-gray-700"
              >
                Cancel
              </button>
              <CustomButton
                label={loading ? "Saving..." : (form?.advocateId ? "Update Advocate" : "Create Advocate")}
                type="submit"
                isDisabled={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdvocatesInfo;